import React from "react";
import { differenceInDays } from "date-fns";
import { createDateFromDDMMYYYY } from "@icarius-utils/date";
import { Grid, Typography, Tooltip } from "@material-ui/core";
import AvatarWithProgress, { getColorByPercentage } from "./avatarWithProgress";
import { getLocalizedString } from "@icarius-localization/strings";

const getFormattedProgress = (value = 0) => {
  return Math.round((value + Number.EPSILON) * 100) / 100
}

const ProgressItem = ({ name, percentage, avatar, data, small }) => {
  return (
    <Grid container style={{ marginTop: 20 }}>
      <Grid container item sm={12} md={small ? 4 : 2} justify='center'>
        <AvatarWithProgress
          name={name}
          percentage={getFormattedProgress(percentage)}
          avatar={avatar}
        />
      </Grid>
      <Grid container item sm={12} md={small ? 8 : 10} style={{ padding: 10 }}>
        <div style={{ display: 'flex', flexDirection: 'column', maxHeight: 460, overflow: 'auto', width: '100%' }}>
          {
            data.map((item, index) => {
              const remainingDays = item.endDate ? differenceInDays(createDateFromDDMMYYYY(item.endDate), new Date()) + 1 : 0;
              return (
                <div key={index} style={{ paddingLeft: 20, paddingBottom: 20 }}>
                  <Typography className="whiteText" style={{ fontWeight: 500, fontSize: '1.1rem' }}>
                    {item.noteName}
                  </Typography>
                  <div style={{ display: 'flex' }}>
                    {
                      item.endDate ?
                        <Tooltip
                          title={
                            <>
                              <Typography
                                align="center"
                                style={{
                                  fontSize: "1rem",
                                  margin: "5px 0px 10px 0px",
                                  fontWeight: 600,
                                }}
                              >
                                {`${getLocalizedString("endDate")}: ${item.endDate}`}
                              </Typography>
                              <Typography style={{ fontSize: '0.95rem', fontWeight: 400, marginBottom: 5 }}>
                                {
                                  remainingDays === 1
                                    ? getLocalizedString("oneDayRemaning")
                                    : remainingDays < 0
                                      ? getLocalizedString("daysDelay", { remainingDays: (remainingDays - 1) * (-1) })
                                      : getLocalizedString("daysRemaning", { remainingDays: (remainingDays - 1) * (-1) })
                                }
                              </Typography>
                            </>
                          }
                          arrow
                        >
                          <div>
                            <Typography style={{ paddingRight: 8, fontWeight: 600, color: getColorByPercentage(getFormattedProgress(item.progress)) }}>
                              {getFormattedProgress(item.progress)}%
                            </Typography>
                            <Typography className="whiteText">
                              {item.taskName}
                            </Typography>
                          </div>
                        </Tooltip> :
                        <>
                          <Typography style={{ paddingRight: 8, fontWeight: 600, color: getColorByPercentage(getFormattedProgress(item.progress)) }}>
                            {getFormattedProgress(item.progress)}%
                          </Typography>
                          <Typography className="whiteText">
                            {item.taskName}
                          </Typography>
                        </>
                    }
                  </div>
                </div>
              )
            })
          }
        </div>
      </Grid>
    </Grid>
  )
}

export default ProgressItem;